/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import translations from './index.json';
import s from 'sprintf-js';
import moment from 'moment';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';

let lang = (navigator.language || navigator.userLanguage || 'en').substring(0, 2);
moment.locale(lang);
/**
 * Generic function to get the translated string from a localizable object, or to translate a string based on index.json definitions
 */
const _ = (name, ...variables) => {
    if (!name || isEmpty(name)) return '';

    if (isObject(name)) {
        if (name[lang]) return name[lang];
        if(!isString(name[lang]) && !isString(name.original)) return '';
        return name.original;
    }

    if (translations[name] !== undefined) {
        if (translations[name][lang]) {
            let str = translations[name][lang];
            if (variables) {
                str = s.sprintf(str, ...variables);
            }
            return str;
        }
    }

    if (!isEmpty(variables)) {
        name = s.sprintf(name, ...variables);
    }
    return name;
};

export default _;
